import {
  GET_DASHBOARD_SPONSORS_LOADING,
  GET_DASHBOARD_SPONSORS_SUCCESS,
  GET_DASHBOARD_SPONSORS_ERROR,
} from "./../../../constant/actionTypes";
const dashboardSponsorsReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case GET_DASHBOARD_SPONSORS_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_DASHBOARD_SPONSORS_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_DASHBOARD_SPONSORS_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};
export default dashboardSponsorsReducer;
